import { userPermissionsActionTypes } from '@constants/actionTypes/userPermissionsActionTypes';

export interface UserPermissionsState {
    list: string[];
    loaded: boolean;
    loading: boolean;
    error: boolean;
}

interface UserPermissionsAction {
    type: string;
    permissions?: string[];
}

export const INITIAL_STATE: UserPermissionsState = {
    list: [],
    loaded: false,
    loading: false,
    error: false,
};

export default (
    state: UserPermissionsState = INITIAL_STATE,
    action: UserPermissionsAction = { type: '' },
): UserPermissionsState => {
    switch (action.type) {
        case userPermissionsActionTypes.FETCH_USER_PERMISSIONS_REQUEST:
            return { ...state, loading: true, error: false };
        case userPermissionsActionTypes.FETCH_USER_PERMISSIONS_SUCCESS:
            return {
                list: action.permissions ?? [],
                loaded: true,
                loading: false,
                error: false,
            };
        case userPermissionsActionTypes.FETCH_USER_PERMISSIONS_FAILURE:
            return {
                list: [],
                loaded: false,
                loading: false,
                error: true,
            };
        default:
            return state;
    }
};
